import { ajv, JSONSchema7WithErrors } from '@cibo/core'

export function createWarningsValidator(schema: JSONSchema7WithErrors) {
  const validate = ajv.compile(schema)
  return (model: any) => {
    const errors: Record<string, string> = {}
    validate(model)
    if (validate.errors) {
      for (const err of validate.errors) {
        const path = err.instancePath
          .slice(1) // remove leading "/"
          .replace(/\//g, '.') // convert "/" separators to "."
        if (path) {
          errors[path] = err.message || 'Warning'
        }
      }
    }
    return errors
  }
}
